import React, { FC } from 'react';
import { Select, Spin } from 'antd';
import { SelectProps } from 'antd/lib/select';

export type ServerSelectProps = Omit<SelectProps<any>, 'showSearch' | 'filterOption' | 'notFoundContent'> & {
  onSearch: (search: string) => void;
  isSearchable?: boolean;
  minSearchLength?: number;
  hintText?: string;
  emptyText?: string;
};

export const ServerSelect: FC<ServerSelectProps> = ({ onSearch, isSearchable = false, minSearchLength = 2, hintText, emptyText = 'Nəticə tapılmadı', loading, style, ...rest }) => {
  const notFoundContent = loading ? (
    <Spin size="small" style={{ display: 'block', padding: '8px 0' }} />
  ) : (
    <span>{isSearchable ? emptyText : (hintText ?? `Ən azı ${minSearchLength} simvol daxil edin`)}</span>
  );

  return <Select allowClear showSearch filterOption={false} onSearch={onSearch} loading={loading} notFoundContent={notFoundContent} style={{ width: '100%', ...style }} {...rest} />;
};
